module.exports = __webpack_public_path__ + "f29cf56d371d19f85b7b296bb6d3c485.png";